import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { CostPriceComponentViewModel } from 'web-shared';
import {ClassificatorValuesQuery} from 'common-shared';
import { CostPriceComponentSurchargeViewModel } from 'web-shared';
import { CostPriceComponentService } from '../cost-price-component.service';
import {NgForm} from "@angular/forms";

@Component({
  selector: 'mes-cost-price-component-edit',
  templateUrl: './cost-price-component-edit.component.html',
})
export class CostPriceComponentEditComponent implements OnInit {
  @Input() cpc: CostPriceComponentViewModel;
  @Output() changed = new EventEmitter<boolean>();
  @ViewChild(NgForm, {static: true}) form: NgForm;

  constructor(public classificatorValueService: ClassificatorValuesQuery, public cpcService: CostPriceComponentService) { }

  ngOnInit() {
    this.form.statusChanges.subscribe(value => {
      this.changed.emit(this.form.pristine);
    });
  }

  setChanged() {
    this.form.controls?.code?.markAsDirty();
    this.changed.emit(this.form.pristine);
  }

  addSurcharge() {
    this.cpc.CostPriceComponentSurcharges = [...this.cpc.CostPriceComponentSurcharges, new CostPriceComponentSurchargeViewModel()];
  }

  remove(surcharge: CostPriceComponentSurchargeViewModel) {
    this.cpc.CostPriceComponentSurcharges = [...this.cpc.CostPriceComponentSurcharges.filter(cpcSurcharge => cpcSurcharge !== surcharge)];
  }

  setDateRange(dateRange: {From: Date, To: Date}, entity: CostPriceComponentSurchargeViewModel) {
    if (entity.FromDate !== dateRange?.From || entity.ToDate !== dateRange?.To) {
      this.changed.emit(false);
    }
    entity.FromDate = dateRange ? dateRange.From : null;
    entity.ToDate = dateRange ? dateRange.To : null;
  }
}
